import { occFetch } from "~/app/api/occ/occFetch";
import { checkoutAddressUrl } from "./checkoutAddressUrl";

export const createAddress = (activeCartId: string, data: object): Promise<Response> => {
  return occFetch(checkoutAddressUrl(activeCartId, "/ship/to/address"), {
    body: JSON.stringify(data),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
};
